import { useMutation } from '@tanstack/react-query'
import { useEffect, useRef } from 'react'

import { authAPI } from '@/api/new-api'
import { toastFactory } from '@/factories'
import { downloadHref, getApiErrorMessage } from '@/utils'

export interface GetChecklistSignatureRequest {
  checklistId: number
}

export interface DownloadChecklistSignatureRequest extends GetChecklistSignatureRequest {
  fileName: string
}

export const exportChecklistSignature = async (data: GetChecklistSignatureRequest) => {
  const response = await authAPI.get<Blob>(`/checklist-assigned/${data.checklistId}/signature`, {
    responseType: 'blob',
  })
  return response.data
}

export const useExportChecklistSignature = () => {
  const objectUrlRef = useRef<string | null>(null)

  const mutation = useMutation({
    mutationFn: async ({ fileName, ...rest }: DownloadChecklistSignatureRequest) => {
      const blob = await exportChecklistSignature(rest)
      if (objectUrlRef.current) URL.revokeObjectURL(objectUrlRef.current)
      objectUrlRef.current = URL.createObjectURL(blob)
      downloadHref(objectUrlRef.current, fileName)
      return objectUrlRef.current
    },
    onError: (error) => {
      toastFactory.error(getApiErrorMessage(error))
    },
  })

  // Note: Clean up the URL object when the hook unmounts
  useEffect(() => {
    return () => {
      if (objectUrlRef.current) URL.revokeObjectURL(objectUrlRef.current)
    }
  }, [])

  return mutation
}
